/*******************************************************
LOAD ON/OFF COURT TABLE
Used on the on/off court stats page for NBA.
********************************************************/

import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function loadCourtOnOffTable(event) {

    // The data to collect to build our table
    let playersOnCourt = [];
    let playersOffCourt = [];
    let team = null;
    let range = null;
    let split = null;

    // Iterate over the modal buttons to get the list of on players and off players
    $('.open-court-on-off-modal').each((index, modalButton) => {
        const $modalButton = $(modalButton);
        const modalButtonCourt = $modalButton.data('court');
        const modalButtonTeam = $modalButton.data('team');

        // Set the team
        if(!team){ team = modalButtonTeam; }

        // Get each player and add them to the appropriate array
        $modalButton.siblings('.court-on-off-player').each((index, player) => {
            const $player = $(player);
            const playerId = $player.data('player');

            if(modalButtonCourt === "on"){
                playersOnCourt.push(playerId);
            } else {
                playersOffCourt.push(playerId);
            }

        });
    });

    // Get the date range
    range = $('#reportrange').val();

    // Get the split
    split = $("input[name='split']:checked").val();

    // Show the toggle tabs
    $('.court-on-off-view-toggle').removeClass('hide');

    // Remove any existing tables and headers
    $('#court-on-off-totals').remove();
    $('#court-on-off-per-36').remove();
    $('#court-on-off-difference-header').remove();
    $('#court-on-off-difference').remove();

    // Build the new table placeholders
    let $onOffStatsTables =
    `<div id="court-on-off-totals" class="mb-20">
        <div class="table-load">
            <div class="table-load__inner">
                <div class="loader"></div>Loading Stats
            </div>
        </div>
    </div>
    <div id="court-on-off-per-36" class="mb-20 hide">
        <div class="table-load">
            <div class="table-load__inner">
                <div class="loader"></div>Loading Stats
            </div>
        </div>
    </div>`;

    // If we supplied any player parameters then show the differential table
    if(playersOnCourt.length > 0 || playersOffCourt.length > 0){
        $onOffStatsTables +=
        `<div id="court-on-off-difference-header" class="heading size-1 boldest upper mb-5">DIFFERENTIAL PER 36</div>
        <div id="court-on-off-difference" class="mb-20">
            <div class="table-load">
                <div class="table-load__inner">
                    <div class="loader"></div>Loading Stats
                </div>
            </div>
        </div>`;
    }

    // Add the table placeholders
    $('.page').append($onOffStatsTables);

    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : '/basketball/tables/court-on-off-stats.php',
            data   : {
                team: team,
                on: playersOnCourt,
                off: playersOffCourt,
                range: range,
                split: split,
            },
            timeout: 25000,
        });

        // Build the totals table data
        let totalData = {
            container: 'court-on-off-totals',
            data: response.players,
            emptyMessage: 'There were no stats found with those settings.',
            leftSplit: 1,
            customFilters: {
                visible: false,
            },
            columns: [
                { id: 'player',
                header: [{ text: '', css: 'columns-head', },{ text: 'Player', css: 'align-l' }],
                css: 'align-l',sort: 'linked-name', sortDirection: 'asc',
                template: function (player) {
                    return '<a href="' + player.URL + '"><span class="hide-until-xs">' + player.firstname + '</span><span class="hide-xs-up">' + player.firstname[0] + '.</span> ' + player.lastname + '</a>';
                  }
                },
                { id: 'games',
                header: [{ text: 'Basic Stats', css: 'columns-head', colspan: 12}, { text: 'G' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'minutes',
                header: ['', { text: 'MIN' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'plusMinus',
                header: ['', { text: '+/-' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'points',
                header: ['', { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'rebounds',
                header: ['', { text: 'REB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'offensiveRebounds',
                header: ['', { text: 'OREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'defensiveRebounds',
                header: ['', { text: 'DREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'assists',
                header: ['', { text: 'AST' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'steals',
                header: ['', { text: 'STL' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'blocks',
                header: ['', { text: 'BLK' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'turnovers',
                header: ['', { text: 'TO' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'fouls',
                header: ['', { text: 'PF' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'fieldGoalsMade',
                header: [{ text: 'Shooting', css: 'columns-head align-c', colspan: 6 }, { text: 'FGM' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fieldGoalAttempts',
                header: ['', { text: 'FGA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointersMade',
                header: ['', { text: '3PM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointerAttempts',
                header: ['', { text: '3PA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowsMade',
                header: ['', { text: 'FTM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowAttempts',
                header: ['', { text: 'FTA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'usage',
                header: [{ text: 'Usage', css: 'columns-head align-c', colspan: 1 }, { text: 'USG %' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPoints',
                header: [{ text: 'FanDuel', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPointsPerMinute',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'draftkingsPoints',
                header: [{ text: 'DraftKings', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'draftkingsPointsPerMinute',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
            ],
        }

        // Build the per36 table data
        let per36Data = {
            container: 'court-on-off-per-36',
            data: response.players,
            emptyMessage: 'There were no stats found with those settings.',
            leftSplit: 1,
            customFilters: {
                visible: false,
            },
            columns: [
                { id: 'player',
                header: [{ text: '', css: 'columns-head', },{ text: 'Player', css: 'align-l' }],
                css: 'align-l',sort: 'linked-name', sortDirection: 'asc',
                template: function (player) {
                    return '<a href="' + player.URL + '"><span class="hide-until-xs">' + player.firstname + '</span><span class="hide-xs-up">' + player.firstname[0] + '.</span> ' + player.lastname + '</a>';
                  }
                },
                { id: 'games',
                header: [{ text: 'Basic Stats', css: 'columns-head', colspan: 12}, { text: 'G' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'minutes',
                header: ['', { text: 'MIN' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'plusMinusPer36',
                header: ['', { text: '+/-' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'pointsPer36',
                header: ['', { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'reboundsPer36',
                header: ['', { text: 'REB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'offensiveReboundsPer36',
                header: ['', { text: 'OREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'defensiveReboundsPer36',
                header: ['', { text: 'DREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'assistsPer36',
                header: ['', { text: 'AST' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'stealsPer36',
                header: ['', { text: 'STL' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'blocksPer36',
                header: ['', { text: 'BLK' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'turnoversPer36',
                header: ['', { text: 'TO' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'foulsPer36',
                header: ['', { text: 'PF' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'fieldGoalsMadePer36',
                header: [{ text: 'Shooting', css: 'columns-head align-c', colspan: 6 }, { text: 'FGM' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fieldGoalAttemptsPer36',
                header: ['', { text: 'FGA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointersMadePer36',
                header: ['', { text: '3PM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointerAttemptsPer36',
                header: ['', { text: '3PA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowsMadePer36',
                header: ['', { text: 'FTM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowAttemptsPer36',
                header: ['', { text: 'FTA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'usage',
                header: [{ text: 'Usage', css: 'columns-head align-c', colspan: 1 }, { text: 'USG %' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPointsPer36',
                header: [{ text: 'FanDuel', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPointsPerMinute',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'draftkingsPointsPer36',
                header: [{ text: 'DraftKings', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'draftkingsPointsPerMinute',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
            ],
        }

        // Build the difference table data
        let differenceData = {
            container: 'court-on-off-difference',
            data: response.players,
            emptyMessage: 'There were no differential stats found with those settings.',
            leftSplit: 1,
            customFilters: {
                visible: false,
            },
            columns: [
                { id: 'player',
                header: [{ text: '', css: 'columns-head', },{ text: 'Player', css: 'align-l' }],
                css: 'align-l',sort: 'linked-name', sortDirection: 'asc',
                template: function (player) {
                    return '<a href="' + player.URL + '"><span class="hide-until-xs">' + player.firstname + '</span><span class="hide-xs-up">' + player.firstname[0] + '.</span> ' + player.lastname + '</a>';
                  }
                },
                { id: 'pointsDifference',
                header: [{ text: 'Basic Stats', css: 'columns-head', colspan: 9}, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'reboundsDifference',
                header: ['', { text: 'REB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'offensiveReboundsDifference',
                header: ['', { text: 'OREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'defensiveReboundsDifference',
                header: ['', { text: 'DREB' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'assistsDifference',
                header: ['', { text: 'AST' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'stealsDifference',
                header: ['', { text: 'STL' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'blocksDifference',
                header: ['', { text: 'BLK' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'turnoversDifference',
                header: ['', { text: 'TO' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'foulsDifference',
                header: ['', { text: 'PF' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'fieldGoalsMadeDifference',
                header: [{ text: 'Shooting', css: 'columns-head align-c', colspan: 6 }, { text: 'FGM' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fieldGoalAttemptsDifference',
                header: ['', { text: 'FGA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointersMadeDifference',
                header: ['', { text: '3PM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'threePointerAttemptsDifference',
                header: ['', { text: '3PA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowsMadeDifference',
                header: ['', { text: 'FTM' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'freeThrowAttemptsDifference',
                header: ['', { text: 'FTA' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'usageDifference',
                header: [{ text: 'Usage', css: 'columns-head align-c', colspan: 1 }, { text: 'USG %' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPointsDifference',
                header: [{ text: 'FanDuel', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'fanduelPointsPerMinuteDifference',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
                { id: 'draftkingsPointsDifference',
                header: [{ text: 'DraftKings', css: 'columns-head align-c', colspan: 2 }, { text: 'PTS' }],
                css: 'align-r',sort: 'number',
                startOfGroup: true,
                },
                { id: 'draftkingsPointsPerMinuteDifference',
                header: ['', { text: 'PTS/MIN' }],
                css: 'align-r',sort: 'number',
                },
            ],
        }

        // Filter empty rows from the difference table data
        differenceData.data = $.grep(differenceData.data, function(p) {
            return p.usageDifference !== '';
        });

        // Sort the difference table data by usage
        differenceData.data.sort(function(a, b){
            return ((a.usageDifference < b.usageDifference) ? 1 : ((a.usageDifference > b.usageDifference) ? -1 : 0));
        });

        function mapCourtOnOffColumns(tableData){
            var heatmapColumns = ['usage','usageDifference'];

            var maxValues = Object.keys(tableData[0] || []).reduce(function(maxList, col){
                if (!heatmapColumns.includes(col)) { return maxList; }
                maxList[col] = Math.max.apply(null, tableData.map(function(r){ return Number(r[col]); }));
                return maxList;
            }, {});

            var minValues = Object.keys(tableData[0] || []).reduce(function(minList, col){
                if (!heatmapColumns.includes(col)) { return minList; }
                minList[col] = Math.min.apply(null, tableData.map(function(r){ return Number(r[col]); }));
                return minList;
            }, {});

            return function(col){
                if (!col.sort) { col.sort = 'number'; }
                if (!col.sortDirection) { col.sortDirection = 'desc'; }
                if (!col.css) { col.css = 'align-r'; }
                if (heatmapColumns.includes(col.id)) {

                    var minValue = minValues[col.id] || 0;
                    var maxValue = maxValues[col.id] || 1000;

                    if(col.sortDirection === 'asc'){
                        col.cssFormat = formatCellRW('heatmap', { min: maxValue , max: minValue });
                    } else {
                        col.cssFormat = formatCellRW('heatmap', { min: minValue , max: maxValue });
                    }
                }
                return col;
            }
        }

        totalData.columns      = totalData.columns.map(mapCourtOnOffColumns(response.players));
        per36Data.columns      = per36Data.columns.map(mapCourtOnOffColumns(response.players));
        differenceData.columns = differenceData.columns.map(mapCourtOnOffColumns(response.players));

        if(!response.paid){
            const paywall = {
                headline: 'Want to see stats for every player?',
                text: 'We\'ve only included a limited number of players in the section above. The rest of our sortable on/off court stats are reserved for RotoWire subscribers.',
                cta: {
                    text: 'Unlock Our Full Stats',
                    link: '/subscribe/',
                }
            }

            totalData.paywall = paywall;
            per36Data.paywall = paywall;
            differenceData.paywall = paywall;
        }


         //Load the tables to the screen
        loadTableRW(totalData);

        loadTableRW(per36Data);

        if(playersOnCourt.length > 0 || playersOffCourt.length > 0){
            loadTableRW(differenceData);
        }
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'There was an error. Please try again.', 3000);
    }
}
